import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'

import { RoleTagId } from '../Users/RoleTag'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const teamColumns: GridColumn[] = [
  {
    title: 'Name',
    field: 'name',
    show: true,
    width: 200,
    sortable: false,
  },
  {
    title: 'Permissions',
    sortable: false,
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.permissions) {
        return <td />
      }

      const userRoleName = props.dataItem.name

      return (
        <td>
          {props.dataItem.permissions.map((permission: { id: number; name: string }) => (
            <RoleTagId userRoleName={userRoleName} role={permission} key={permission.id} />
          ))}
        </td>
      )
    },
  },
]

export default teamColumns
